/* Klikours sur Dawn : selecteur modele/offres, date de livraison, barre d'achat fixe, retour en haut, lots dans le panier */
(function () {
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function nativeInputs() {
    return document.querySelectorAll('variant-selects input[type=radio]');
  }

  function pick(name, val) {
    var ins = nativeInputs();
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].name.trim() === name && ins[i].value === val) {
        if (!ins[i].checked) {
          ins[i].checked = true;
          ins[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  // Dawn remonte vers la photo de la variante choisie (une seule photo d'ours) :
  // sur les offres, on garde le client là où il est
  function holdScroll() {
    var y = window.scrollY;
    var native = window.scrollTo;
    window.scrollTo = function () {};
    setTimeout(function () {
      window.scrollTo = native;
      if (Math.abs(window.scrollY - y) > 40) native.call(window, 0, y);
    }, 1500);
  }

  // Aligne les boutons Klikours sur la variante reellement selectionnee (ex. ?variant= dans l'URL)
  function syncPicker() {
    var ins = nativeInputs();
    for (var i = 0; i < ins.length; i++) {
      if (!ins[i].checked) continue;
      var name = ins[i].name.trim();
      var val = ins[i].value;
      document.querySelectorAll('.kk-picker [data-opt]').forEach(function (b) {
        if (b.getAttribute('data-opt') !== name) return;
        var on = b.getAttribute('data-val') === val;
        b.classList.toggle('is-on', on);
        if (on && b.classList.contains('kk-model')) {
          var l = document.querySelector('[data-kk-ml]');
          if (l) l.textContent = val;
        }
      });
    }
  }

  function currentPrice() {
    var pr = document.querySelector('div[id^=price-] .price');
    if (!pr) return '';
    var el = pr.classList.contains('price--on-sale')
      ? pr.querySelector('.price-item--sale')
      : pr.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : '';
  }

  function syncSticky() {
    var p = currentPrice();
    document.querySelectorAll('[data-kk-sp]').forEach(function (el) {
      if (p) el.textContent = p;
    });
  }

  function fillDates() {
    function f(n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      return d.getDate() + ' ' + MOIS[d.getMonth()];
    }
    document.querySelectorAll('[data-kk-d1]').forEach(function (el) { el.textContent = f(7); });
    document.querySelectorAll('[data-kk-d2]').forEach(function (el) { el.textContent = f(12); });
  }

  // Panier : une ligne « 3 achetés + 2 offerts » en quantité 1 = 5 ours. On l'écrit en clair.
  function markLots() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var details = row.querySelector('.cart-item__details');
      if (!details) return;
      var txt = details.textContent;
      var per = /3 achet/.test(txt) ? 5 : /2 achet/.test(txt) ? 3 : 0;
      var old = details.querySelector('.kk-lot');
      if (!per) { if (old) old.remove(); return; }
      var q = row.querySelector('.quantity__input');
      var lots = q ? parseInt(q.value, 10) || 1 : 1;
      var n = per * lots;
      var model = '';
      details.querySelectorAll('.product-option').forEach(function (o) {
        var dt = o.querySelector('dt');
        if (dt && /Mod/.test(dt.textContent)) model = o.querySelector('dd').textContent.replace(/,\s*$/, '').trim();
      });
      var html = '📦 <strong>' + (lots > 1 ? lots + ' lots = ' : 'Lot de ') + n + ' ours</strong> livrés' +
        (model ? ' (' + model + ')' : '') + ' + ' + n + ' marteaux offerts + le guide.' +
        '<br><span>La quantité « ' + lots + ' » compte les lots, pas les ours.</span>';
      if (old && old.getAttribute('data-n') === String(n)) return;
      if (!old) {
        old = document.createElement('div');
        old.className = 'kk-lot';
        var anchor = details.querySelector('dl') || details.lastElementChild;
        anchor.parentNode.insertBefore(old, anchor.nextSibling);
      }
      old.setAttribute('data-n', String(n));
      old.innerHTML = html;
    });
  }

  function lotStyles() {
    if (document.getElementById('kk-lot-css')) return;
    var s = document.createElement('style');
    s.id = 'kk-lot-css';
    s.textContent = '.kk-lot{margin:.8rem 0;padding:.7rem .9rem;border-radius:8px;background:#FFF1E3;border:1px solid #F07B22;color:#1D1D1F;font-size:1.3rem;line-height:1.45}.kk-lot strong{color:#C55A0E}.kk-lot span{color:#6B5E52;font-size:1.2rem}';
    document.head.appendChild(s);
  }

  var lotTimer;
  new MutationObserver(function () {
    clearTimeout(lotTimer);
    lotTimer = setTimeout(markLots, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var up = e.target.closest('.kk-up');
    if (up) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var b = e.target.closest('.kk-picker [data-opt]');
    if (b) {
      if (b.classList.contains('kk-offer')) holdScroll();
      pick(b.getAttribute('data-opt'), b.getAttribute('data-val'));
      var g = b.parentNode.querySelectorAll('[data-opt]');
      for (var i = 0; i < g.length; i++) g[i].classList.toggle('is-on', g[i] === b);
      if (b.classList.contains('kk-model')) {
        var l = document.querySelector('[data-kk-ml]');
        if (l) l.textContent = b.getAttribute('data-val');
      }
      setTimeout(syncSticky, 900);
      return;
    }
    var sb = e.target.closest('.kk-sticky-b');
    if (sb) {
      var a = document.querySelector('.product-form__submit');
      if (a) a.click();
    }
  });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var s = document.querySelector('.kk-sticky');
      if (!s) return;
      var a = document.querySelector('.product-form__submit');
      var on = !!(a && a.getBoundingClientRect().bottom < 0);
      s.classList.toggle('is-on', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) syncSticky();
    });
  }, { passive: true });

  // Offre Halloween : fin réelle le 31/10/2026 à 23:59:59 (heure de Paris, UTC+1 après le 25/10)
  var HW_END = Date.parse('2026-10-31T23:59:59+01:00');
  function tickHalloween() {
    var left = HW_END - Date.now();
    var els = document.querySelectorAll('[data-kk-hw]');
    if (left <= 0) {
      for (var i = 0; i < els.length; i++) els[i].style.display = 'none';
      return false;
    }
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var txt = (d > 0 ? d + ' j ' : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(s) + ' s';
    var cds = document.querySelectorAll('[data-kk-cd]');
    for (var j = 0; j < cds.length; j++) cds[j].textContent = txt;
    return true;
  }
  if (tickHalloween()) {
    var hwTimer = setInterval(function () { if (!tickHalloween()) clearInterval(hwTimer); }, 1000);
  }

  function init() {
    tickHalloween();
    fillDates();
    syncPicker();
    syncSticky();
    lotStyles();
    markLots();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Microsoft Clarity (projet z1890t0py0) : enregistrements de sessions et cartes de chaleur.
   Le consentement suit la bannière cookies Shopify : sans accord, Clarity reste sans cookie. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'z1890t0py0');

  function sendConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return;
    var ok = cp.analyticsProcessingAllowed();
    var ads = typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
    window.clarity('consentv2', { analytics_Storage: ok ? 'granted' : 'denied', ad_Storage: ads ? 'granted' : 'denied' });
  }
  document.addEventListener('visitorConsentCollected', sendConsent);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) sendConsent(); });
  }
})();
